const getters = {
  // ifUserLogin: state => state.user.ifUserLogin,
}

export default getters
